<template>
  <div class="animated fadeIn">
    <template v-if="base">
    <List v-show="list" ref="list" @count="(count) => is_first = count < 1" />
    </template>
    <Upload v-show="upload" ref="upload_csv" />
    <Detail v-if="detail" @refresh="refresh" :is_first="is_first" @count="(count) => is_first = count < 1" />
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>